import React from 'react'

import userAvatar from '../../assets/user-avatar.svg'
import { trackedClick, getMarkedCookieValue } from '../../utils'
import SvgIcon from '../SvgIcon'

class TrackedLinkWithNext extends React.Component {
    render() {
        const { title, href, button } = this.props
        return (
            <a
                tabIndex="0"
                className={
                    button
                        ? 'button button--sm button--gray button--outline'
                        : 'dropdown__menu-link'
                }
                onClick={this.handleClick}
                href={href}
                title={title}
            >
                {title}
            </a>
        )
    }

    handleClick = e => {
        e.preventDefault()
        const { title, to = '', next } = this.props
        trackedClick(`Go to console${to} clicked`, {
            source: 'Header',
            title,
        })(e)
        const url =
            global.INTENTO_CONSOLE_URL || process.env.INTENTO_CONSOLE_URL

        if (next) {
            window.location = `${url}${to}?next=${window.location}#mt-demo`
        } else {
            window.location = `${url}${to}?from=${window.location}#mt-demo`
        }
    }
}

class LoggedUser extends React.Component {
    state = {
        open: false,
    }

    render() {
        const { user } = this.props
        const { open } = this.state
        const username = user === 'yes' ? 'You are signed in' : user // TODO legacy value, remove in Jan-Feb
        return (
            <li
                className={`header__nav-item header__nav-item--user dropdown ${
                    open ? 'dropdown--open' : ''
                }`}
            >
                <div
                    className="dropdown__control"
                    onClick={this.handleClick}
                    onKeyPress={this.handleClick}
                    role="button"
                    tabIndex="0"
                >
                    <span className="header__user-avatar">
                        <img src={userAvatar} alt="" />
                    </span>
                    <span className="header__user-content">{username}</span>
                    <span className="dropdown__control-arrow">
                        <SvgIcon slug="chevron-down" />
                    </span>
                </div>
                <div className="dropdown__menu">
                    <div className="dropdown__menu-inner">
                        <ul className="dropdown__menu-list">
                            <li className="dropdown__menu-item">
                                <TrackedLinkWithNext
                                    title="Console Dashboard"
                                    to="/dashboard"
                                />
                            </li>
                            <li className="dropdown__menu-item">
                                <TrackedLinkWithNext
                                    title="Sign out"
                                    to="/logout"
                                    next
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        )
    }

    handleClick = () => {
        this.setState({ open: !this.state.open })
    }
}

class ButtonToConsole extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            consoleUser: getMarkedCookieValue('CU'),
        }
    }

    render() {
        const { consoleUser } = this.state

        if (consoleUser) {
            // TODO get design with console user email
            return <LoggedUser user={consoleUser} />
        }

        return (
            <li className="header__nav-item header__nav-item--button">
                <TrackedLinkWithNext title="Sign up" button next />
            </li>
        )
    }
}

export default ButtonToConsole



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/Header/ButtonToConsole.jsx